var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountProfileEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H6C5.45 6 5.005 6.45 5.005 7L5 13C5 13.55 5.45 14 6 14H14C14.55 14 15 13.55 15 13V7C15 6.45 14.55 6 14 6ZM13.8 8.125L10.265 10.335C10.105 10.435 9.895 10.435 9.735 10.335L6.2 8.125C6.14986 8.09686 6.10596 8.05883 6.07094 8.01323C6.03593 7.96762 6.01053 7.91539 5.99629 7.85969C5.98204 7.80398 5.97925 7.74597 5.98808 7.68915C5.99691 7.63234 6.01717 7.57791 6.04764 7.52915C6.07811 7.48039 6.11816 7.43833 6.16536 7.4055C6.21256 7.37267 6.26594 7.34976 6.32225 7.33815C6.37856 7.32654 6.43664 7.32648 6.49298 7.33797C6.54931 7.34946 6.60273 7.37227 6.65 7.405L10 9.5L13.35 7.405C13.3973 7.37227 13.4507 7.34946 13.507 7.33797C13.5634 7.32648 13.6214 7.32654 13.6778 7.33815C13.7341 7.34976 13.7874 7.37267 13.8346 7.4055C13.8818 7.43833 13.9219 7.48039 13.9524 7.52915C13.9828 7.57791 14.0031 7.63234 14.0119 7.68915C14.0207 7.74597 14.018 7.80398 14.0037 7.85969C13.9895 7.91539 13.9641 7.96762 13.9291 8.01323C13.894 8.05883 13.8501 8.09686 13.8 8.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProfileEmailIcon);
export default __webpack_public_path__ + "static/media/account-profile-email-icon.f6393c1e661a92027076907b08f52589.svg";
export { ForwardRef as ReactComponent };